import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  will-change: transform;
  width: 100vw;
  height: 100vh;
`
export const Reposition = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ${props =>
    props.bounds === 'half' &&
    `
    right: 50vw;
  `}
`
